import cx from 'classnames';
import Layer from 'components/Layer';
import LayerTrigger from 'components/LayerTrigger';
import Tooltip from 'components/Tooltip';
import createReactClass from 'create-react-class';
import Formsy from 'lib/Formsy';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import createChainedFunction from 'utils/createChainedFunction';
import focusNode from 'utils/focusNode';
import pickInputElementProps from 'utils/pickInputElementProps';
import './styles/FormCellInput.scss';

const FormCellInput = createReactClass({
  propTypes: {
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    warningMessage: PropTypes.string,
    validations: PropTypes.any,
    validationError: PropTypes.any,
    errorMessage: PropTypes.string,
    onChange: PropTypes.func,
    parsePasteWith: PropTypes.func,
    autofocus: PropTypes.bool,
  },

  mixins: [Formsy.Mixin],

  getInitialState() {
    return {
      focus: false,
      wasBlurred: false,
      value: this.props.value,
      wasJustMounted: true,
    };
  },

  componentWillMount() {
    if (this.props.value) {
      this.setValue(this.props.value); // To make the input not pristine
    }
  },

  componentDidMount() {
    if (this.props.autofocus) {
      // Prevents the cursor from being placed at the start of the text
      const node = this.refs.input;
      const value = node.value;
      node.value = '';
      focusNode(node);
      node.value = value;
    }

    this.interval = setInterval(this.lookForChanges, 1000);
  },

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.changeValue(nextProps.value);
    }
  },

  shouldComponentUpdate(nextProps, nextState) {
    return !(isEqual(this.props, nextProps) && isEqual(this.state, nextState));
  },

  componentWillUnmount() {
    const { interval } = this;
    if (interval) {
      clearInterval(interval);
    }
  },

  onFocus() {
    this.setState({ focus: true });
  },

  onBlur() {
    this.setState({ focus: false });
    if (this.state.wasBlurred === false) {
      this.setState({ wasBlurred: true });
    }
  },

  onChange(event) {
    this.changeValue(event.currentTarget.value);
  },

  onPaste(e) {
    if (this.props.parsePasteWith) {
      e.stopPropagation();
      if (this.props.parsePasteWith(e)) {
        e.preventDefault();
      }
    }
  },

  changeValue(value) {
    this.setState({
      value,
      wasBlurred: false,
      wasJustMounted: false,
    });
  },

  /* This is for autofill purposes.
   * Some browsers does not emit change event when
   * they fill out the forms, so Formsy is not aware
   * the value change and the validation does not run.
   * This pulls the value from the DOM at
   * regular interval and if what is found is different
   * than what Formsy currently have then we tell Formsy
   * about this new value via the Formsy mixin.
   */
  lookForChanges() {
    if (!this.refs.input) {
      return;
    }

    const fieldVal = this.refs.input.value;
    if (fieldVal && this.getValue() !== fieldVal) {
      this.onChange({ currentTarget: { value: fieldVal } });
    }
  },

  render() {
    let errorMessage = this.getErrorMessage();

    const { value, onChange, onBlur, warningMessage, ...others } = this.props;

    if (!value || (!this.state.wasBlurred && !this.state.wasJustMounted) || this.isPristine()) {
      errorMessage = null;
    }

    errorMessage = this.props.errorMessage || errorMessage;

    let tooltip = <Layer />;
    if (errorMessage) {
      tooltip = <Tooltip color="apple">{errorMessage}</Tooltip>;
    } else if (warningMessage) {
      tooltip = <Tooltip color="elmer">{warningMessage}</Tooltip>;
    }

    const inputProps = pickInputElementProps(others);
    return (
      <LayerTrigger layer={tooltip} placement="bottom" alignment="left" trigger={['hover']}>
        <div
          className={cx('FormCellInput', {
            'FormCellInput--focus': this.state.focus,
            'FormCellInput--error': errorMessage,
            'FormCellInput--warning': warningMessage,
          })}>
          <input
            // MDN claims that onpaste is "non-standard and is not on a standards track" here:
            // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/onpaste
            // But the w3 working draft describing this behavior can be found here:
            // https://www.w3.org/TR/clipboard-apis/#the-paste-action
            // It appears to function as intended in Chrome, Firefox, Safari, and IE latest.
            onPaste={this.onPaste}
            {...inputProps}
            ref="input"
            value={this.state.value}
            className="FormCellInput-input"
            onFocus={this.onFocus}
            onBlur={createChainedFunction(onBlur, this.onBlur)}
            onChange={createChainedFunction(onChange, this.onChange)}
          />
        </div>
      </LayerTrigger>
    );
  },
});

export default FormCellInput;
